import { render, staticRenderFns } from "./PollUserResponses.vue?vue&type=template&id=c95639e4"
import script from "./PollUserResponses.vue?vue&type=script&lang=js"
export * from "./PollUserResponses.vue?vue&type=script&lang=js"
import style0 from "./PollUserResponses.vue?vue&type=style&index=0&id=c95639e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports